import { forwardRef } from "react";
import type { PropsWithChildren } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, IconButton, Slide } from "@mui/material";
import type { DialogContentProps, DialogProps } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import styles from "./DialogWithExit.module.scss";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return (
    <Slide
      direction="up"
      ref={ref}
      {...props}
    />
  );
});

interface DialogWithExitProps {
  dialogProps: DialogProps;
  dialogContentProps?: DialogContentProps;
  useSlide?: boolean;
  inquiryDialog?: boolean;
  onExit: (e: any) => void;
}

function DialogWithExit({
  dialogProps,
  dialogContentProps,
  children,
  useSlide,
  inquiryDialog = false,
  onExit,
}: PropsWithChildren<DialogWithExitProps>) {
  const customStylesChanges = inquiryDialog
    ? {
        ".MuiDialog-paper": {
          padding: 0,
        },
      }
    : undefined;

  return (
    <Dialog
      {...dialogProps}
      TransitionComponent={useSlide ? Transition : undefined}
      sx={customStylesChanges}
    >
      <DialogContent {...dialogContentProps}>
        <div className={styles.exitBttnContainer}>
          <div className={styles.exitBttnInner}>
            <IconButton
              color="inherit"
              onClick={onExit}
              data-testid="close-button"
            >
              <CloseIcon color="inherit" />
            </IconButton>
          </div>
        </div>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export default DialogWithExit;
